/* istanbul ignore file */
// TODO add unit tests for this component and remove the line above to include this file in coverage calculation
import React from 'react';
import { HorizontalWrapper } from 'moet-core';
import { SpacerHorizontal } from '@klarna/bubble-ui';
import { CallToActionButton, ContainerTemplate, SecondaryButton } from '@/components';
import { CardsSelector } from '@/bpc/components/CardsSelector';
import { findFieldByAbsolutePath } from '@/bpc/utils/onboardingGroup';
import { validateHasSensitiveGoods } from '@/bpc/utils/sensitiveGoods';
import { logEvent } from '@/utils/analytics';
import { ANALYTICS_EVENTS } from '@/bpc/utils/analyticsEvents';
const SENSITIVE_GOODS_FIELD_PATH = 'sensitive_goods';
export class SensitiveGoodsGroupComponent extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onNext = this.onNext.bind(this);
        this.validateIsRequired = this.validateIsRequired.bind(this);
        this.preventNavigation = this.preventNavigation.bind(this);
        this.setSensitiveGoodsErrorMessage = this.setSensitiveGoodsErrorMessage.bind(this);
        this.setRequiredErrorMessage = this.setRequiredErrorMessage.bind(this);
        this.setValidatorErrorMessage = this.setValidatorErrorMessage.bind(this);
        this.state = {
            highlightMandatoryButEmptyFields: false,
            isDisabled: false,
            errorMessage: undefined,
            isRequiredErrorMessage: undefined,
            validatorErrorMessage: undefined,
            value: this.props.group.getValueForField(this.props.group.fields[0][0].absolutePath),
        };
    }
    setSensitiveGoodsErrorMessage(relatedErrorMessage) {
        const { group } = this.props;
        this.setState({
            value: group.getValueForField(SENSITIVE_GOODS_FIELD_PATH),
            errorMessage: relatedErrorMessage,
        });
    }
    setValidatorErrorMessage() {
        const { group } = this.props;
        const field = findFieldByAbsolutePath(group, SENSITIVE_GOODS_FIELD_PATH);
        const value = group.getValueForField(SENSITIVE_GOODS_FIELD_PATH);
        const validator = field.validator;
        this.setState({
            value,
            errorMessage: validator && !validator.callback(value) ? validator.errorMessage() : undefined,
        });
    }
    setRequiredErrorMessage() {
        const { t, group } = this.props;
        const field = findFieldByAbsolutePath(group, SENSITIVE_GOODS_FIELD_PATH);
        const label = t(field.label) || field.fallbackLabel;
        this.setState({
            isRequiredErrorMessage: `${label} ${this.props.t('products-fe.errors.mandatoryField')}`,
        });
    }
    onChange(value) {
        const group = this.props.group;
        const field = findFieldByAbsolutePath(group, SENSITIVE_GOODS_FIELD_PATH);
        group.setValueOfField(field, value);
        this.setState({
            value: group.getValueForField(SENSITIVE_GOODS_FIELD_PATH),
            isRequiredErrorMessage: undefined,
            errorMessage: undefined,
            highlightMandatoryButEmptyFields: false,
        });
        logEvent(ANALYTICS_EVENTS.submitSensitiveGoods, {
            sellsSensitiveGoods: group.getValueForField(SENSITIVE_GOODS_FIELD_PATH),
        });
    }
    validateIsRequired() {
        const { group } = this.props;
        const field = findFieldByAbsolutePath(group, SENSITIVE_GOODS_FIELD_PATH);
        const value = group.getValueForField(field.absolutePath);
        const isMandatory = field.mandatory();
        const isApplicable = field.applicable();
        const isRequired = isApplicable && isMandatory && (value == null || value === '' || value === undefined);
        if (isRequired) {
            this.setState({
                highlightMandatoryButEmptyFields: true,
            });
            this.setRequiredErrorMessage();
        }
        return isRequired;
    }
    preventNavigation() {
        const { t, group } = this.props;
        const isRequired = this.validateIsRequired();
        const hasSensitiveGood = validateHasSensitiveGoods(group);
        const shouldPreventNavigation = isRequired || hasSensitiveGood;
        if (shouldPreventNavigation) {
            if (hasSensitiveGood) {
                this.setSensitiveGoodsErrorMessage(t('fields.enm.sensitive_good_category.error_message'));
            }
            else if (isRequired) {
                const field = findFieldByAbsolutePath(group, SENSITIVE_GOODS_FIELD_PATH);
                const label = t(field.label) || field.fallbackLabel;
                this.setSensitiveGoodsErrorMessage(`${label} ${t('products-fe.errors.mandatoryField')}`);
            }
        }
        return shouldPreventNavigation;
    }
    onNext() {
        const { hasNextGroup, onNextGroup, onShowSummaryPage } = this.props;
        if (this.preventNavigation()) {
            return;
        }
        if (hasNextGroup) {
            onNextGroup();
        }
        else {
            onShowSummaryPage();
        }
    }
    render() {
        const { group, error, hasPreviousGroup, onPreviousGroup, isLoading, t } = this.props;
        const field = group.fields[0][0];
        return (React.createElement(ContainerTemplate, { title: t('group.title.sensitive_goods') || group.fallbackTitle, subtitle: t('group.subtitle.sensitive_goods') || group.fallbackSubtitle, error: error },
            React.createElement(CardsSelector, { value: group.getValueForField(field.absolutePath), onChange: this.onChange, options: field === null || field === void 0 ? void 0 : field.enumOptions(), error: this.state.errorMessage, showErrorOnTop: !this.state.highlightMandatoryButEmptyFields }),
            React.createElement(HorizontalWrapper, { display: "inline-flex", alignItems: "center", justifyContent: "flex-end" },
                hasPreviousGroup && (React.createElement(React.Fragment, null,
                    React.createElement(SecondaryButton, { onClick: onPreviousGroup }, t('products-fe.general.buttons.back')),
                    React.createElement(SpacerHorizontal, { medium: true }))),
                React.createElement(CallToActionButton, { onClick: this.onNext, loading: isLoading }, t('products-fe.general.buttons.continue')))));
    }
}
